/**
 * "Inbound" as a Flow filter value (SPEC-2383).
 *
 * Inbound calls are not driven by a flow, so they can't be selected through a
 * flow id. The call stats modal offers this sentinel in the same multi-select
 * as the org's flows; it is split back out before the GraphQL request so the
 * backend receives real flow ids plus an `includeInbound` flag.
 */
export const INBOUND_FLOW_FILTER = '__inbound__';

export const INBOUND_FLOW_OPTION = { value: INBOUND_FLOW_FILTER, label: 'Inbound' };

export interface FlowFilterSelection {
  /** Real flow ids, or undefined when none are selected. */
  flowIds: string[] | undefined;
  /** True when the Inbound option is part of the selection. */
  includeInbound: boolean | undefined;
}

export const splitFlowFilterSelection = (selected: readonly string[]): FlowFilterSelection => {
  const flowIds = selected.filter((id) => id && id !== INBOUND_FLOW_FILTER);
  const includeInbound = selected.includes(INBOUND_FLOW_FILTER);
  return {
    flowIds: flowIds.length ? flowIds : undefined,
    includeInbound: includeInbound || undefined,
  };
};
